module.exports = __webpack_public_path__ + "media/assets/images/column-thumbnail_medical-6b0d7e97b81caab8525b5c5001a4d5a9.png";